import React from 'react';
import { defaultTheme } from '@nxsys/constants/defaultConfig';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconFileImport: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = defaultTheme.theme.palette.neutral[700],
  disabled = false,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1084 7.05833L12.1084 2.05833C11.9909 1.94083 11.8326 1.875 11.6667 1.875H6.66675C4.65175 1.875 3.54175 2.985 3.54175 5V15C3.54175 17.015 4.65175 18.125 6.66675 18.125H14.1667C16.1817 18.125 17.2917 17.015 17.2917 15V7.5C17.2917 7.33417 17.2259 7.175 17.1084 7.05833ZM12.2917 4.00917L15.1576 6.875H14.1667C12.8526 6.875 12.2917 6.31417 12.2917 5V4.00917ZM14.1667 16.875H6.66675C5.35258 16.875 4.79175 16.3142 4.79175 15V5C4.79175 3.68583 5.35258 3.125 6.66675 3.125H11.0417V5C11.0417 7.015 12.1517 8.125 14.1667 8.125H16.0417V15C16.0417 16.3142 15.4809 16.875 14.1667 16.875ZM12.2917 12.5C12.2917 12.845 12.0117 13.125 11.6667 13.125H9.00928L9.60925 13.725C9.85342 13.9692 9.85342 14.365 9.60925 14.6092C9.48759 14.7308 9.32756 14.7925 9.16756 14.7925C9.00756 14.7925 8.84754 14.7317 8.72587 14.6092L7.0592 12.9425C7.0017 12.885 6.95598 12.8158 6.92432 12.7392C6.86098 12.5867 6.86098 12.4142 6.92432 12.2617C6.95598 12.185 7.0017 12.1158 7.0592 12.0583L8.72587 10.3917C8.97004 10.1475 9.3659 10.1475 9.61007 10.3917C9.85423 10.6358 9.85423 11.0317 9.61007 11.2758L9.01009 11.8758H11.6667C12.0117 11.875 12.2917 12.155 12.2917 12.5Z"
      fill={disabled ? defaultTheme.theme.palette.neutral[400] : color}
    />
  </svg>
);

export default IconFileImport;
